import React, { useState, useEffect } from "react";
import { Button, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Link, useLocation, useParams } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import AddIcon from '@mui/icons-material/Add';
import sizeConfigs from "../configs/sizeConfigs";
import { ArrowBack } from '@mui/icons-material';
import { useDispatch, useSelector } from "react-redux";
import { devIsSidenav, devIsSidenavdefault } from "../../../dev_store/slice/side_navbar";
import { AnyAsyncThunk } from "@reduxjs/toolkit/dist/matchers";
import RootState from "../../../dev_store/store";
import {
  ArrowLeftIcon
} from '@shopify/polaris-icons';
import { Icon } from "@shopify/polaris";
import "../apps_sidenav/apps_sidebar.scss"


const AppsSidebar = () => {


  const [openNested, setOpenNested] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const { slug } = useSelector((state: RootState) => {
    const storedSlug = localStorage.getItem('slug');
    return {
      slug: storedSlug || state.appCreatedResponse.slug, // If storedSlug is null or undefined, use the slug from state
    };
  });
  const { appID } = useParams();




  // Now you can use api_key, api_secret, app_id, and slug in your component
  // For example:



  useEffect(() => {

    const isNestedRoute = nestedRoutes.some((route) => location.pathname.startsWith(route.path));
    if (isNestedRoute) {
      setOpenNested(true);
    } else {
      setOpenNested(false);
    }
  }, [location.pathname, slug]);

  const handleNestedClick = () => {
    setOpenNested(!openNested);
  };


  const nestedRoutes = [
    { path: "/developer/createApps", icon: <AddIcon />, name: "Create Apps" },
  ];
  const handleBackButtonClick = () => {
    dispatch(devIsSidenav({ sidenav: false }));
    dispatch(devIsSidenavdefault());
    window.location.href = "/developer/apps";
  };

  return (
    <div style={{}} className="container">

      <Drawer
        variant="permanent"
        className="sidenav-label"
        sx={{


          width: sizeConfigs.sidebar.width,
          flexShrink: 0,
          "& .MuiDrawer-paper": {

            width: sizeConfigs.sidebar.width,
            paddingTop: "65px",
            alignContent: "flex-start",
            background: "#f6f6f7"
          },
          "& .MuiListItem-root": {

            height: "32px",
            color: "#202223",
            "&.active": {
              color: "green",
              backgroundColor: "#f0f0f0", // Gray background when selected
            },
            "&:hover": {  // Remove hover color when not clicked
              backgroundColor: "transparent",
            },
          },
          "& .css-10hburv-MuiTypography-root ": {
            height: "32px",
            fontFamily: "-apple-system,BlinkMacSystemFont,San Francisco,Segoe UI,Roboto,Helvetica Neue,sans-serif",
            margin: "0",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: 2.0,
            display: "block",
            marginTop: "var(--p-space-1)",
            marginBottom: "var(--p-space-1)"
          },


          "& .MuiListItemButton-root": {

            // fontWeight: "bold",
            // fontSize: "14px",
            paddingLeft: "7px",
            color: "inherit",
            "&.active": {
              color: "green",
            },
            "&:hover": {  // Remove hover color when not clicked
              backgroundColor: "transparent",
            },
          },
          "& .MuiListItemText-primary": {

            // fontSize: "14px",
            // fontWeight: "bold",
            // color: "grey",
          },
          "& .MuiListItemIcon-root": {

            // fontWeight: "700",
            // fontSize: "14px",
            justifyContent: "space-around",
            color: "inherit", // Inherit the color from ListItemButton
            "&.active": {
              color: "green", // Change icon color when active
            },
          },
          "& .nested": {
            "&.active": {
              backgroundColor: "#202223", // Inherit gray background when selected
            },
            "&:hover": {
              backgroundColor: "transparent", // Remove hover color for nested items
            },
          },
        }}
      >
        <div className="container">
          <List style={{ paddingLeft: 10, fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", fontSize: "14px" }} disablePadding>

            <div>

              <div onClick={handleBackButtonClick} style={{ paddingTop: "5px", display: "flex", alignItems: "center" }}>


                <div>
                  <Icon

                    source={ArrowLeftIcon}
                    tone="base"
                  />
                </div>



                <label style={{ fontSize: "0.875rem", fontWeight: "500", lineHeight: "1.2rem", color: "#202223", verticalAlign: "middle", paddingLeft: "8px",fontFamily: "-apple-system,BlinkMacSystemFont,San Francisco,Segoe UI,Roboto,Helvetica Neue,sans-serif", }}>ALL APPS</label>
              </div>
              <div style={{ marginTop: "10px" }}>
                <div style={{ paddingLeft: "5px", lineHeight:"1.5rem",fontSize: "1rem", fontWeight: "600", fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif" }}>
                  {slug}
                </div>
                <ListItem sx={{ marginTop: "10px", fontSize: "14px", textAlign: "left" }} disablePadding className={location.pathname === `/developer/${appID}/appoverview` ? "active" : ""}>
                  <ListItemButton component={Link} to={`/developer/${appID}/appoverview`}>
                    {/* <ListItemIcon>

                  </ListItemIcon> */}
                    <ListItemText primary="Overview" />
                  </ListItemButton>
                </ListItem>
              </div>

              {/* <div style={{ paddingLeft: "5px", marginTop: "5px", fontSize: "12px", fontWeight: "600", fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif", color: "grey" }}>
                {"Build"}
              </div> */}
              <ListItem sx={{ fontSize: "0.875rem" }} disablePadding className={location.pathname === `/developer/${appID}/edit/managelist` ? "active" : ""}>
                <ListItemButton component={Link} to={`/developer/${appID}/edit/managelist`}>
                  {/* <ListItemIcon>
                </ListItemIcon> */}
                  <ListItemText primary="App Listing" />
                </ListItemButton>
              </ListItem>
              <ListItem sx={{ fontSize: "14px", }} disablePadding className={location.pathname === `/developer/${appID}/edit` ? "active" : ""}>
                <ListItemButton component={Link} to={`/developer/${appID}/edit`}>
                  {/* <ListItemIcon>
                </ListItemIcon> */}
                  <ListItemText primary="App Configurations" />
                </ListItemButton>
              </ListItem>

              <ListItem sx={{ fontSize: "14px" }} disablePadding className={location.pathname === `/developer/${appID}/edit/permissions` ? "active" : ""}>
                <ListItemButton component={Link} to={`/developer/${appID}/edit/permissions`}>
                  {/* <ListItemIcon>
                </ListItemIcon> */}
                  <ListItemText primary="API Access" />
                </ListItemButton>
              </ListItem>
              <ListItem sx={{ fontSize: "14px" }} disablePadding className={location.pathname === `/developer/${appID}/edit/plan` ? "active" : ""}>
                <ListItemButton component={Link} to={`/developer/${appID}/edit/plan`}>
                  {/* <ListItemIcon>
                </ListItemIcon> */}
                  <ListItemText primary="Plan" />
                </ListItemButton>
              </ListItem>
           
            </div>

          </List>
        </div>
      </Drawer>
    </div>
  );
};
interface RootState {
  appCreatedResponse: {
    api_key: string;
    api_secret: string;
    app_id: string;
    slug: string;
  };
  // other state definitions...
}
export default AppsSidebar;